export const GC_SUPPORT_ORIGIN = "https://support.gocardless.com";

export const ZENDESK_SUPPORT_FORMS = {
  login: 12073927770780,
  verification: 15060555285916,
};
